import React, { useState, useEffect } from "react";
import Header from "@/components/common/header/DefaultHeader";
import './InTheNews.css';
import { getWebCMS } from '@/api/PDP';
import MobileMenu from '@/components/common/header/MobileMenu';
import parse from "react-html-parser"; // To parse HTML content
import MetaComponent from "@/components/common/MetaComponent";
import OtherLinkFooter from "../common/footer/OtherLinkFooter";
import NewFooter from "../common/footer/NewFooter";

const InTheNews = () => {
  const [cmsData, setCmsData] = useState({});
  const [newsData, setNewsData] = useState([]);

  useEffect(() => {
    // Fetch CMS data and handle dynamic keys
    getWebCMS("pages/inTheNews").then((response) => {
      const data = response?.results[0] || {};
      setCmsData(data);

      // Dynamically gather all news items from the CMS data
      const news = Object.keys(data)
        .filter((key) => key.startsWith("news")) // Include keys starting with "news"
        .map((key) => ({
          header: data[key]?.header,
          date: data[key]?.date,
          logo: data[key]?.logo,
          content: data[key]?.content,
          content1: data[key]?.content1,
          navLink: data[key]?.navLink,
        }));
      setNewsData(news);
    });
  }, []);
  const metadata = {
    title: 'Hubzu | In the news',
  }
  const data = [
    {
      header: cmsData?.news1?.header,
      date: cmsData?.news1?.date,
      logo: cmsData?.news1?.logo,
      content: cmsData?.news1?.content,
      navlink: cmsData?.news1?.navlink
    },
    {
      header: cmsData?.news2?.header,
      date: cmsData?.news2?.date,
      logo: cmsData?.news2?.logo,
      content: cmsData?.news2?.content
    },
    {
      header: cmsData?.news3?.header,
      date: cmsData?.news3?.date,
      logo: cmsData?.news3?.logo,
      content: cmsData?.news3?.content
    },
    {
      header: cmsData?.news4?.header,
      date: cmsData?.news4?.date,
      logo: cmsData?.news4?.logo,
      content: cmsData?.news4?.content
    }, {
      header: cmsData?.news5?.header,
      date: cmsData?.news5?.date,
      logo: cmsData?.news5?.logo,
      content: cmsData?.news5?.content
    },
  ]
  return (
    <>
     <MetaComponent meta={metadata} />
      <Header />
      <MobileMenu />
      <header className="stricky-fixed"></header>
      <div className="in-the-news">
        {/* Page Title */}
        <div className="news-page-title-section ">
          <h1 className="news-page-title">{cmsData?.title || "In The News"}</h1>
        </div>

        {/* News Items */}
        {newsData.map((item, index) => (
          <React.Fragment key={index}>
            <div
              className="news-container px-3 px-lg-5"
              style={{ marginTop: "40px" }}
            >
              {/* News Logo */}
              {item?.logo && (
                <div className="col-3 news-img">
                  <a href={item.navLink} target="_blank"><img src={item.logo} alt="Logo" className="news-logo" /></a>
                </div>
              )}

              {/* News Content */}
              <div className="col-9 news-content">
                {item?.header && (
                  <div>
                    {item?.navLink ? (
                      <a className="header_news" href={item.navLink} target="_blank">{item.header}</a>
                    ) : (
                      item.header
                    )}
                  </div>
                )}
                {item?.date && <div className="news-subheader">{item.date}</div>}

                {/* Parse HTML content */}
                {item?.content && (
                  <div className="news-paragraph">{parse(item.content)}</div>
                )}
                {item?.content1 && (
                  <div className="news-paragraph">{parse(item.content1)}</div>
                )}
              </div>
            </div>
            <hr />
          </React.Fragment>
        ))}
      </div>

      {/* Footer */}
      {/* <section className="footer_one home6 bg-ptrn2">
        <div className="container">
          <div className="row">
            <Footer />
          </div>
        </div>
      </section> */}
       <div className="container-fluid px-0">
              {/* <Footer /> */}
              <OtherLinkFooter />
              <NewFooter />
            </div>
    </>
  );
};

export default InTheNews;
